import React from "react"
import styled from "@emotion/styled"
//import MobileLogo from "-!svg-react-loader!../../assets/icons/nutrafol-logo-m.svg"
import DesktopLogo from "-!svg-react-loader!../../assets/icons/nutrafol-logo.svg"

import { clearStateAndExit } from "../../utils/clearStateAndExit"

const LogoArea = styled.div`
`
const LogoHolder = styled.div`
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  width: 140px;
  svg {
    width: 100%;
    margin: 0 auto;
    height: 18px;
  }

  @media (min-width: 1024px) {
    width: 156px;
    svg {
      height: 20px;
    }
  }
`
const FakeLink = styled.div`
`

const Logo = props => {

  return (
    <LogoArea className="logo-wrap">
      <FakeLink
        className="fake-link"
        onClick={clearStateAndExit}
      >
        <LogoHolder>
          {/*<MobileLogo className="hide-md-up" />*/}
          <DesktopLogo />
        </LogoHolder>
      </FakeLink>
    </LogoArea>
  )
}

export default Logo
